import TabDadosGeraisCliente from './TabDadosGeraisCliente';

const { default: ClienteDadosGeraisPessoaFisica } = require('./ClienteDadosGeraisPessoaFisica');

export { ClienteDadosGeraisPessoaFisica, TabDadosGeraisCliente };
